/*
 * @Description: 组织架构
 * @Author: mdb
 * @Date: 2022-08-09 14:57:20
 * @LastEditTime: 2023-06-15 15:52:18
 * @LastEditors: cxh
 */
import { ref, onBeforeMount } from 'vue'
import { getDeptInfo, getCustomerArea } from '@/api/common'
import { useRequest } from 'vue-request'

// interface User {
//   code: string
//   userId: number
// }
// interface DeptInfo {
//   id: string
//   label: string
//   leaderUId: number
//   level: string
//   supComCode: number
//   supDepCode: string
//   user: User[]
//   children: DeptInfo[]
// }
// interface CustomerArea {
//   appId: string
//   id: string
//   name: string
//   parentId: string
//   path: string
//   weight: number
//   children?: CustomerArea[]
// }

/**
 * 获取谷仓客户区域 -- 默认过滤只要国内销售部门 '815718'
 *
 * @param {string} [rootId='815718'] 根节点id
 */
const getCustomerAreaFbu = async (rootId = '815718') => {
  return new Promise((resolve, reject) => {
    const params = { appId: 'cos_fbu', rootId }
    useRequest(getDeptInfo, {
      defaultParams: [params],
      cacheKey: 'appId_deptInfo' + JSON.stringify(params),
      onSuccess: (res) => {
        const list = res.data.deptInfo[0]?.children
        resolve(list)
      },
      onError(Error) {
        reject(Error)
      }
    })
  })
}
/**
 * 获取谷仓海外客户区域 -- 默认过滤只要国内销售部门 '815717'
 *
 * @param {string} [rootId='815717'] 根节点id
 */
const getCustomerAreaOfbu = async (rootId = '815717') => {
  const params = { appId: 'cos_ofbu', rootId }
  return new Promise((resolve, reject) => {
    useRequest(getDeptInfo, {
      defaultParams: [params],
      cacheKey: 'appId_deptInfo' + JSON.stringify(params),
      onSuccess: (res) => {
        const list = res.data.deptInfo
        resolve(list)
      },
      onError(Error) {
        reject(Error)
      }
    })
  })
}
/**
 * 获取云途客户区域
 * @returns
 */
const getCustomerAreaLbu = async () => {
  const params = { appId: 'cos_lbu' }
  return new Promise((resolve, reject) => {
    useRequest(getCustomerArea, {
      defaultParams: [params],
      cacheKey: 'appId_deptInfo' + JSON.stringify(params),
      onSuccess: (res) => {
        const list = res.data
        resolve(list)
      },
      onError(Error) {
        reject(Error)
      }
    })
  })
}

export default function (appId?: 'cos_fbu' | 'cos_ofbu' | 'cos_lbu', deptInfoId?: string) {
  const customerAreaEnum = ref<any>([])
  onBeforeMount(async () => {
    if (appId === 'cos_fbu') {
      customerAreaEnum.value = await getCustomerAreaFbu(deptInfoId)
    }
    if (appId === 'cos_ofbu') {
      customerAreaEnum.value = await getCustomerAreaOfbu()
    }
    if (appId === 'cos_lbu') {
      customerAreaEnum.value = await getCustomerAreaLbu()
    }
  })
  return {
    customerAreaEnum,
    getCustomerAreaFbu,
    getCustomerAreaOfbu,
    getCustomerAreaLbu
  }
}
